module.exports = __webpack_public_path__ + "img/tab.de731dc6.png";